import {
    PersonInformationProviderEnum,
    personInformationProviderEnumOptions,
} from './../../../../../../../../types/src/services/enum/person-information-provider.enum';
import {
    personDataVerificationEnumOptions,
} from './../../../../../../../../types/src/services/enum/person-data-verification.enum';
import {
    personSupportMeasureEnumOptions,
} from './../../../../../../../../types/src/services/enum/person-support-measure.enum';
import { nationalityEnumOptions } from './../../../../../../../../types/src/common/enum/country-code.enum';
import { Component, computed, effect, input, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { age } from '../../../../shared/pipes/age.pipe';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { translate } from '../../../../shared/shared.global-service';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { DateInputComponent } from '../../../../../components/kit/input/date-input/date-input.component';
import { NumberInputComponent } from '../../../../../components/kit/input/text-input/number-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { CheckInputComponent } from '../../../../../components/kit/input/check-input/check-input.component';
import { ErrorFloatMessageComponent } from '../../../../../components/kit/float-message/error-float-message.component';

@Component({
    selector: 'app-person-additional-info',
    templateUrl: './person-additional-info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardComponent,
        DateInputComponent,
        NumberInputComponent,
        TranslatePipe,
        SelectInputComponent,
        Tooltip,
        TextInputComponent,
        CheckInputComponent,
        ErrorFloatMessageComponent,
    ],
})
export class PersonAdditionalInfoComponent extends SubscriptionComponent {

    public form = input.required<FormGroup | null>();
    public canEdit = input(false);
    public errorMsg = input<string | null>(null);

    protected birthdate: WritableSignal<Date | null> = signal(null);
    protected estimatedBirthYear: WritableSignal<number | null> = signal(null);
    protected estimatedBirthdate = computed(() => this.estimatedBirthYear() ? new Date(this.estimatedBirthYear()!, 0, 1) : null);
    protected currentAge = computed(() => age(this.birthdate() || this.estimatedBirthdate()));
    protected minor = computed(() => this.currentAge() < 18);

    protected prefix = 'user.';

    today = new Date();

    constructor() {
        super();
        effect(() => {
            // This creates a signal out of valueChanges observable
            // form is required, but it is not yet available in the constructor
            const form = this.form();
            if (form) {
                this.subs.forEach((sub) => sub?.unsubscribe());
                this.subs.push(
                    form.get('birthdate')!.valueChanges.subscribe((val) => {
                        this.birthdate.set(val);
                    }),
                    form.get('estimatedBirthYear')!.valueChanges.subscribe((val) => {
                        this.estimatedBirthYear.set(val);
                    }),
                );
            }
        });
    }


    protected readonly nationalityEnumOptions = nationalityEnumOptions
        .map((it) => {
            it.name = translate.instant(it.name);
            return it;
        })
        .sort((a, b) => a.name > b.name ? 1 : -1)
    ;

    protected readonly supportMeasureEnumOptions = personSupportMeasureEnumOptions;
    protected readonly infoProviderEnumOptions = personInformationProviderEnumOptions;
    protected readonly dataVerificationEnumOptions = personDataVerificationEnumOptions;

    protected readonly InfoProviderEnum = PersonInformationProviderEnum;
}
